$(document).ready(function () {
    createBetterPagination();
});

document.addEventListener('ShoptetDOMContentLoaded', function () {
    createBetterPagination();
});

function createBetterPagination() {
    const $pagination = $('.pagination__list');
    if (!$pagination.length) return;

    const currentPage = parseInt($('.pagination__currentPage').text());
    const lastPage = parseInt($('.pagination__link--last').text());
    if (!currentPage || !lastPage) return;

    const prevLink = $('.pagination__link--prev').attr('href');
    const nextLink = $('.pagination__link--next').attr('href');

    let pagePrefix = 'strana-';

    // 🔥 získáme base + query z next/last linku
    let sampleUrl = nextLink || $('.pagination__link--last').attr('href') || '';

    let urlParts = sampleUrl.split('?');
    let path = urlParts[0];
    let query = urlParts[1] ? '?' + urlParts[1] : '';

    let cleanPath = path.replace(new RegExp(pagePrefix + '\\d+\\/'), '');

    // 🔥 mapa existujících odkazů
    let linksMap = {};
    $('.pagination__link').each(function () {
        const page = parseInt($(this).text());
        const href = $(this).attr('href');
        if (!isNaN(page) && href && href !== '#') {
            linksMap[page] = href;
        }
    });

    function getPageUrl(page) {
        if (linksMap[page]) return linksMap[page];

        if (page === 1) return cleanPath + query;

        return `${cleanPath}${pagePrefix}${page}/${query}`;
    }

    let pages = [currentPage - 1, currentPage, currentPage + 1];

    pages = pages.filter(p => p > 0 && p <= lastPage);

    let html = '';

    if (prevLink) {
        html += `
        <li class="prev">
            <a class="pagination__link pagination__link--prev btn btn-secondary" href="${prevLink}">
            </a>
        </li>`;
    }

    if (pages[0] > 1) {
        html += `<li><a class="pagination__link" href="${getPageUrl(1)}">1</a></li>`;
        if (pages[0] > 2) html += `<li class="pagination__dots">...</li>`;
    }

    pages.forEach(page => {
        if (page === currentPage) {
            html += `
            <li>
                <strong class="pagination__currentPage" aria-current="page">${page}</strong>
            </li>`;
        } else {
            html += `
            <li>
                <a class="pagination__link" href="${getPageUrl(page)}">${page}</a>
            </li>`;
        }
    });

    if (pages[pages.length - 1] < lastPage) {
        if (pages[pages.length - 1] < lastPage - 1) {
            html += `<li class="pagination__dots">...</li>`;
        }
        html += `
        <li>
            <a class="pagination__link pagination__link--last" href="${getPageUrl(lastPage)}">
                ${lastPage}
            </a>
        </li>`;
    }

    if (nextLink) {
        html += `
        <li class="next">
            <a class="pagination__link pagination__link--next btn btn-secondary" href="${nextLink}">
          
            </a>
        </li>`;
    }

    $pagination.html(html);
}